/*eslint-disable */
/**
 * Time functions.
 */
define(
['mustache', 'underscore'],
function(Mustache, _) {
	var _self = {
		apiTimeFormat: "H:i",

		/**
		 * Generates array of values for creating a time select.
		 *
		 * @param int from            Minutes to start generating from
		 * @param int to              Minutes to end generating
		 * @param int step            Minutes from the last value to the next one
		 * @param string format       OPTIONAL Time format for the shown title, default is H:i
		 * @param function selectFunc OPTIONAL Function that defines which element must be selected. It should accept
		 *                            minutes as integer and step. It must return true when the element needs to be selected
		 * @param boolean withTemplate OPTIONAL Should the format be passed through Mustache templating engine?
		 * 							  {@see toFormattedWithTemplate}
		 * @return Array of {minutes: 15, value: "00:15", title: "Title"[, selected: true //if selectFunc returned true//}
		 */
//		getTimeFieldValues: function (from, to, step, format, selectFunc, withTemplate) {
//			var list = [];
//			var formatMethod;
//			format   = format || "H:i";
//
//			if (withTemplate) {
//				formatMethod = "toFormattedWithTemplate";
//			} else {
//				formatMethod = "toFormatted";
//			}
//
//			while (from <= to) {
//				var item = {
//					minutes: from,
//					value: this[formatMethod](from, "H:i"),
//					title: this[formatMethod](from, format)
//				};
//				if (typeof selectFunc == "function" && selectFunc(from, step)) {
//					item.selected = true;
//				}
//				list.push(item);
//
//				from += step;
//			}
//			return list;
//		},

		/**
		 * Returns SELECT options for venue startTime..endTime.
		 *
		 * @param Object options OPTIONAL. Possible values:
		 * > (int) step Minutes to step
		 *
		 * @return string
		 */
//		getVenueWorkTimeHourSelect: function(options) {
//			options || (options = {});
//			var workStart = this.timeToMinutes(App.config.get('venue').dayStartsAt);
//			var workEnd   = this.timeToMinutes(App.config.get('venue').dayEndsAt);
//			var step      = (options.step || App.config.get('venue').appointmentSlotDuration);
//			var templateOptions = this.getTimeFieldValues(
//				workStart,
//				workEnd,
//				step,
//				App.config.get('dateFormat').defaultTime
//			);
//			return Wahanda.Template.renderTemplate("form-select-items", {options: templateOptions});
//		},

		/**
		 * Converts minutes to a formatted string.
		 *
		 * Escaping of characters can be done by prefixing them with "\".
		 *
		 * @param int time Minutes
		 * @param string format Format with values from the `formats`
		 * @return string
		 */
		toFormatted: function(time, format) {
			var returnStr = '';
			var skipNext  = false;
			for (var i = 0, len = format.length; i < len; i++) {
				var curChar = format.charAt(i);
				if (curChar === '\\' && !skipNext) {
					skipNext = true;
				} else if (!skipNext && _.isFunction(this.formats[curChar])) {
					returnStr += this.formats[curChar](Math.floor(time / 60), time % 60);
				} else {
					returnStr += curChar;
					skipNext = false;
				}
			}
			return returnStr;
		},

		toApiString: function(time) {
			return this.toFormatted(time, this.apiTimeFormat);
		},

		/**
		 * Converts the given minutes to default time.
		 *
		 * @param int time
		 * @return strign
		 */
//		toDefaultTime: function(time) {
//			return this.toFormatted(
//				time,
//				App.config.get('dateFormat').defaultTime
//			);
//		},

		/**
		 * Get minutes passed since 00:00 in the given date.
		 *
		 * @param Date date
		 * @return int
		 */
		getDateMinutes: function(date) {
			return date.getHours() * 60 + date.getMinutes();
		},

		getDateApiTime: function(date) {
			return _self.toApiString(
				_self.getDateMinutes(date)
			);
		},

		/**
		 * Does the same as {@see toFormatted}, but with format pre-parsing as a Mustache templte.
		 *
		 * It exposes two boolean mustache variables: hour, minute. If hour or minute equals 0, the variable is false.
		 * Otherwise - it's true.
		 *
		 * @param int time
		 * @param string template
		 * @return string
		 */
		toFormattedWithTemplate: function(time, template) {
			var isHour = time >= 60;
			var isMinute = time % 60 !== 0;

			var format = Mustache.render(template, {hour: isHour, minute: isMinute});
			return this.toFormatted(time, format);
		},

		/**
		 * Time in format H:i is converted into minutes from 00:00.
		 *
		 * @param string time
		 * @return int
		 */
		timeToMinutes: function(time) {
			var result = 0;
			var match  = null;
			if (time && (match = String(time).match(/^(\d{1,2}):(\d{1,2})$/))) {
				result = parseInt(match[1], 10) * 60 + parseInt(match[2], 10);
			}
			return result;
		},

		minutesToTimeHash: function(minutes) {
			minutes = parseInt(minutes, 10);
			return {
				hours  : Math.floor(minutes / 60),
				minutes: minutes % 60
			};
		},

		/**
		 * Returns string which has "\" added before each characted so that {@see toFormatted} won't escape any
		 * special characters.
		 *
		 * @param String string
		 * @return String
		 */
		escapeFormatting: function(string) {
			return string ? "\\" + String(string).split("").join("\\") : "";
		},

		/**
		 * Creates a function which compares two times and returns TRUE if the given number is the closest match.
		 * Returns a callback function which can be passed to Wahanda.Time.getTimeFieldValues as the `selectFunc` parameter.
		 *
		 * @param int | string time Time to compare to
		 * @param int step
		 * @param int startsFrom Time from which will be counted
		 * @return function
		 */
		getNearestSelectFunc: function(time, step, startsFrom) {
			if (typeof time == "string") {
				time = this.timeToMinutes(time);
			}
			time += startsFrom % step;

			var matchesStep = (time % step === 0);
			var halfStep    = step / 2;
			var returned    = false;

			return function (currentMinutes, outerStep) {
				if (returned) {
					// This function returns TRUE only once
					return false;
				}
				if (matchesStep) {
					// Time matches exactly one step
					return (returned = time === currentMinutes);
				} else {
					return (returned = Math.abs(time - currentMinutes) <= halfStep);
				}
			};
		},

		/**
		 * Supported time formats.
		 */
		formats: {
			// Time
			a: function(h, m) {
				return h < 12 ? 'am' : 'pm';
			},
			A: function(h, m) {
				return h < 12 ? 'AM' : 'PM';
			},
			B: function(h, m) {
				return "Not Yet Supported";
			},
			g: function(h, m) {
				return h % 12 || 12;
			},
			G: function(h, m) {
				return h;
			},
			h: function(h, m) {
				return ((h % 12 || 12) < 10 ? '0' : '') + (h % 12 || 12);
			},
			H: function(h, m) {
				return (h < 10 ? '0' : '') + h;
			},
			i: function(h, m) {
				return (m < 10 ? '0' : '') + m;
			}
		},

		/**
		 * Returns formatted and translated duration.
		 *
		 * @param int time
		 * @param string type MI for minutes, DY for days
		 * @return string
		 */
//		duration: function(time, type) {
//			if ("MI" === type) {
//				var result = Math.round((isNaN(time) ? 0 : time) / 60, 1);
//				return result + " " + Wahanda.lang.time.duration.abbr[result > 1 ? "hours":  "hour"];
//			} else {
//				return time + " " + Wahanda.lang.time.duration[time > 1 ? "days":  "day"];
//			}
//		},

		/**
		 * Returns duration in full format (Hours and Minutes separate)
		 *
		 * @param int time
		 * @return string
		 */
		getDurationFull: function(time) {
			return this.toFormattedWithTemplate(
				time,
				this.getTimeDurationTemplate()
			);
		},

		/**
		 * Generates array of values for duration time selects.
		 *
		 * @param int selected        OPTIONAL Time to select
		 * @param string format       OPTIONAL Time format for the shown title, default is H:i
		 * @param boolean withTemplate OPTIONAL Should the format be passed through Mustache templating engine?
		 * 							  {@see toFormattedWithTemplate}
		 * @param Object options      OPTIONAL Hash of parameters:
		 * > minMinutes (int) Minimum minutes resturned in results
		 * @return Array of {minutes: 15, value: "00:15", title: "Title"[, selected: true //if selectFunc returned true//}
		 */
		getDurationValues: function (selected, format, withTemplate, options) {
			var list = [];
			var formatMethod;
			format   = format || "H:i";
			options  = (options || {});
			var minMinutes = options.minMinutes || 10;

			if (withTemplate) {
				formatMethod = "toFormattedWithTemplate";
			} else {
				formatMethod = "toFormatted";
			}

			var self = this;
			var addTimeToList = function(startHour, endHour, increment, selectFunc) {
				for (var hour = startHour; hour < endHour; hour++) {
					for (var min = (hour > 0 ? 0 : increment); min < 60; min += increment) {
						var minutes = hour * 60 + min;
						if (minutes < minMinutes) {
							continue;
						}
						list.push({
							minutes: minutes,
							value  : self[formatMethod](minutes, "H:i"),
							title  : self[formatMethod](minutes, format),
							selected: typeof selectFunc === "function" && !!selectFunc(minutes, increment)
						});
					}
				}
			}

			var selectFunc;
			if (selected) {
				var firstSelectedCheck = true;
				selectFunc = function(check, step) {
					if (firstSelectedCheck) {
						firstSelectedCheck = false;
						if (selected <= minMinutes) {
							// Select the first value, because the selected one is lower than the minimum
							return true;
						}
					}
					return selected === check || selected > check && selected < check + step;
				};
			}

			addTimeToList(0, 2, 5, selectFunc);
			addTimeToList(2, 4, 15, selectFunc);
			addTimeToList(4, 8, 30, selectFunc);
			addTimeToList(8, 12, 60, selectFunc);

			var lastHour = 12;
			list.push({
				minutes : 60 * lastHour,
				value   : this[formatMethod](60 * lastHour, "H:i"),
				title   : this[formatMethod](60 * lastHour, format),
				selected: typeof selectFunc === "function" && !!selectFunc(60 * lastHour, 60)
			});
			return list;
		},

		/**
		 * Returns hour difference between two given, as float.
		 *
		 * @param String less time in format HH:MM
		 * @param String more time in format HH:MM
		 * @return float
		 */
		getHourDiff: function(less, more) {
			var first  = this.splitHours(less);
			var second = this.splitHours(more);

			return (second.hours + second.minutes / 60) - (first.hours + first.minutes / 60);
		},

		/**
		 * Splits hours intu hours and minutes.
		 *
		 * @param String hours time in format HH:MM
		 * @return {hours, minutes}
		 */
		splitHours: function(hours) {
			var match = String(hours).match(/^(\d{1,2}):(\d{1,2})$/);
			if (match) {
				return {
					hours  : parseInt(match[1], 10),
					minutes: parseInt(match[2], 10)
				}
			} else {
				return { hours: 0, minutes: 0 };
			}
		},

//		getTimeDurationTemplate: function() {
//			return '{{#hour}}G '
//				 + this.escapeFormatting(Wahanda.lang.time.duration.mini.hour)
//				 + ' {{/hour}}'
//				 + '{{#minute}}i '
//				 + this.escapeFormatting(Wahanda.lang.time.duration.abbr.minutes)
//				 + '{{/minute}}';
//		},

		/**
		 * Returns difference, in human-readable format, between the two times.
		 *
		 * @param String from
		 * @param String to
		 * @return String duration in getTimeDurationTemplate() format
		 */
//		getDifference: function(from, to) {
//			var diff = this.timeToMinutes(to) - this.timeToMinutes(from);
//			return this.getDurationFull(diff);
//		},

		/**
		 * Do the given time ranges overlap?
		 *
		 * TimeRange type is { from: HH:MM, to: HH:MM } OR { from: minutes, to: minutes }
		 *
		 * @param TimeRange time1
		 * @param TimeRange time2
		 * @param boolean   strict OPTIONAL Strict checking (e.g. if end matches start, should it count as overlap?)
		 * 						Defaults to TRUE.
		 * @return boolean
		 */
		doesOverlap: function(time1, time2, strict) {
			strict = (arguments.length === 2 ? true : strict);
			var start1 = toMins(time1.from);
			var start2 = toMins(time2.from);
			var end1   = toMins(time1.to);
			var end2   = toMins(time2.to);
			// (StartA <= EndB) and (EndA >= StartB)
			if (strict) {
				return start1 <= end2 && end1 >= start2;
			}
			return start1 < end2 && end1 > start2;

			function toMins(time) {
				return isNaN(time) ? _self.timeToMinutes(time) : time;
			}
		},

		/**
		 * Makes a prettin time range, in format HH:MM - HH:MM, or in 12 hour one.
		 * @param String|int from
		 * @param String|int to
		 * @return String
		 */
		prettyTimeRange: function(from, to) {
			from = isNaN(from) ? this.timeToMinutes(from) : from;
			to   = isNaN(to) ? this.timeToMinutes(to) : to;

			if (App.config.get('dateFormat').use24h) {
				template = 'H:i';
			} else {
				template = 'g{{#minute}}:i{{/minute}}A';
			}

			return this.toFormattedWithTemplate(from, template) + "-" + this.toFormattedWithTemplate(to, template);
		}
	};

	return _self;
});
